import { useCallback, useContext, useMemo, useState } from 'react';

import { GiftCardContext } from '../../context/GiftCardContext';

import { ReactComponent as GoGiftLogo } from '../../assets/gogift.svg';
import GoGiftLogoBlack from '../../assets/gogift.png';
import BabySamLogo from '../../assets/babysam-giftcard.svg';

import GiftcardModal from '../../pages/modals/GiftcardModal';

import './giftcard.scss';

/* ============================================ Main Component ============================================ */
const Giftcard = () => {
    const {
        showGiftCard,
        data: { key: product, amount, campaign },
        strings
    } = useContext(GiftCardContext);
    const [showDetails, setShowDetails] = useState<boolean>(false);

    const isBlackweek = useMemo(() => campaign === 'blackweek', [campaign]);
    const isChild = useMemo(() => product === 'child', [product]);
    const isBabysam = useMemo(() => product === 'childTB', [product]);

    const stringSurfix = useMemo(() => {
        let suffix = '';
        if (isChild) {
            suffix = '.child';
        } else if (isBabysam) {
            suffix = '.childTB';
        }
        return suffix;
    }, [isChild, isBabysam]);

    const handleOnClickShowGiftcardDetails = useCallback((e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        setShowDetails(true);
    }, []);

    const handleOnCloseGifrcardDetailsModal = useCallback(() => {
        setShowDetails(false);
    }, []);

    const getGiftcardLogo = useMemo(() => {
        let logo;
        if (isBlackweek) {
            logo = <img src={GoGiftLogoBlack} width={100} alt="GoGift Logo" />;
        } else if (isBabysam) {
            logo = <img src={BabySamLogo} width={100} alt="Babysam Logo" />;
        } else {
            logo = <GoGiftLogo />;
        }
        return logo;
    }, [isBabysam, isBlackweek]);

    return showGiftCard ? (
        <>
            <div
                className={`giftcard-container ${isBlackweek ? 'giftcard-container-campaign-blackweek' : 'giftcard-container-campaign-default'}`}
            >
                <div className="giftcard-logo">{getGiftcardLogo}</div>
                <div className="giftcard-inner-container">
                    <div className="giftcard-text">
                        <div className="giftcard-text-header">
                            {strings[`intro.header${stringSurfix}`].replace('{amount}', amount)}
                        </div>
                        <div style={{ paddingTop: '15px' }}>
                            {strings[`intro.text${stringSurfix}`].replace('{amount}', amount)}
                        </div>
                        {isChild ? (
                            <div style={{ paddingTop: '15px', fontSize: '12px', lineHeight: '16px' }}>
                                {strings[`intro.footer.child`]}
                            </div>
                        ) : null}
                    </div>
                    <div
                        className={`giftcard-more-info ${isBlackweek ? 'giftcard-more-info-blackweek' : 'giftcard-more-info-default'}`}
                    >
                        <a
                            data-testid="giftcard-show-details-link"
                            href="/"
                            title="Info"
                            onClick={handleOnClickShowGiftcardDetails}
                        >
                            Info
                        </a>
                    </div>
                </div>
            </div>

            <GiftcardModal
                show={showDetails}
                title={strings['shoppingcart.header']}
                content={strings[`shoppingcart.expand${stringSurfix}`]}
                amount={amount}
                closeHandler={handleOnCloseGifrcardDetailsModal}
            />
        </>
    ) : null;
};

export { Giftcard };
